import { Controller } from "@hotwired/stimulus"

// Handles the "Sync from Meta" button for WhatsApp templates
// Sends POST request to sync endpoint and shows feedback
export default class extends Controller {
  static targets = ["buttonText", "loadingText", "spinner"]
  static values = { url: String }

  async sync(event) {
    event.preventDefault()

    this.showLoading()

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken
        }
      })

      const data = await response.json()

      if (data.success) {
        showSuccessNotification(data.message || 'Sincronização iniciada!')
        setTimeout(() => window.location.reload(), 2000)
      } else {
        showErrorNotification(data.error || 'Erro ao sincronizar')
        this.hideLoading()
      }
    } catch (error) {
      console.error('Sync error:', error)
      showErrorNotification('Erro de conexão')
      this.hideLoading()
    }
  }

  showLoading() {
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.classList.add('hidden')
    }
    if (this.hasLoadingTextTarget) {
      this.loadingTextTarget.classList.remove('hidden')
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('animate-spin')
    }
    this.element.disabled = true
    this.element.classList.add('opacity-75', 'cursor-not-allowed')
    this.startDotsAnimation()
  }

  hideLoading() {
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.classList.remove('hidden')
    }
    if (this.hasLoadingTextTarget) {
      this.loadingTextTarget.classList.add('hidden')
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('animate-spin')
    }
    this.element.disabled = false
    this.element.classList.remove('opacity-75', 'cursor-not-allowed')
    this.stopDotsAnimation()
  }

  startDotsAnimation() {
    if (!this.hasLoadingTextTarget) return

    const baseText = this.loadingTextTarget.dataset.baseText || 'Sincronizando'
    this.loadingTextTarget.innerHTML = `${baseText}<span class="inline-block w-[1em] text-left"></span>`
    this.dotCount = 0

    this.dotsInterval = setInterval(() => {
      this.dotCount = (this.dotCount % 3) + 1
      const dots = '.'.repeat(this.dotCount)
      this.loadingTextTarget.innerHTML = `${baseText}<span class="inline-block w-[1em] text-left">${dots}</span>`
    }, 400)
  }

  stopDotsAnimation() {
    if (this.dotsInterval) {
      clearInterval(this.dotsInterval)
      this.dotsInterval = null
    }
  }

  disconnect() {
    this.stopDotsAnimation()
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }
}
